<template>
  <h1>Patience, patience ... ;)</h1>
</template>
<script>
export default {
  components: {
  }
};
</script>
<style></style>
